module.exports = __webpack_public_path__ + "assets/img/5c4410e8d8166a95b6437b649e63cca4.svg";